import { Workflow } from '../types'
import { apiService } from './api.service'

export class WorkflowService {
  async listAll(params: any = {}): Promise<{ results: Workflow[]; count: number }> {
    const response = await apiService.get('workflows/', params)
    return response.data
  }

  async getWorkflow(id: number): Promise<Workflow> {
    const response = await apiService.get(`workflows/${id}/`)
    return response.data
  }

  async createWorkflow(data: Partial<Workflow>): Promise<Workflow> {
    const response = await apiService.post('workflows/', data)
    return response.data
  }

  async updateWorkflow(id: number, data: Partial<Workflow>): Promise<Workflow> {
    const response = await apiService.patch(`workflows/${id}/`, data)
    return response.data
  }

  async deleteWorkflow(id: number): Promise<void> {
    await apiService.delete(`workflows/${id}/`)
  }
}

export const workflowService = new WorkflowService()
